import React from "react";

const BLUR_STYLE = {
  filter: "blur(8px)",
  userSelect: "none",
  WebkitUserSelect: "none",
  pointerEvents: "none",
};

/**
 * Blurs sensitive dashboard amounts when privacy mode is on.
 * Shows the real value underneath so layout stays stable.
 */
export default function PrivacyBlur({
  hidden = false,
  children,
  as: Tag = "span",
  className,
  style,
  ...rest
}) {
  return (
    <Tag
      className={className}
      style={{
        display: "inline-block",
        transition: "filter 0.2s ease",
        ...style,
        ...(hidden ? BLUR_STYLE : null),
      }}
      aria-hidden={hidden || undefined}
      {...rest}
    >
      {children}
    </Tag>
  );
}
